
import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Activity } from 'lucide-react';
import { VideoFeatures } from '@/store/useVideoFeatures';
import { t } from '@/utils/i18n';

interface RepeatConfigProps {
  features: VideoFeatures;
  setFeature: <K extends keyof VideoFeatures>(key: K, value: VideoFeatures[K]) => void;
}

export const RepeatConfig: React.FC<RepeatConfigProps> = ({ features, setFeature }) => {
  const handleLoopChange = (value: boolean) => {
    // Set both for maximum compatibility
    setFeature('loop', value);
    setFeature('loopVideo', value);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between p-4 rounded-[12px] border border-[#E4E7EC] bg-white">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <Activity className="h-5 w-5 text-primary" />
          </div>
          <div>
            <Label className="text-sm font-medium">{t('autoRepeat')}</Label>
            <p className="text-xs text-muted-foreground">{t('autoRepeatInfo')}</p>
          </div>
        </div>
        <Switch 
          checked={!!features.loop || !!features.loopVideo}
          onCheckedChange={handleLoopChange}
        />
      </div>
    </div>
  );
};
